import { Link } from "react-router-dom";
import { Library } from "lucide-react";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger } from "@/components/ui/select";
import { money } from "@/lib/format";

export const ProductPicker = ({ id, products, category, onPick, cur }) => {
  const list = products.filter((p) => p.category === category);
  return (
    <Select value="" onValueChange={(pid) => { const p = list.find((x) => x.id === pid); if (p) onPick(p); }}>
      <SelectTrigger data-testid={id} className="h-9 w-9 shrink-0 px-0 justify-center bg-white [&>svg:last-child]:hidden" title="Pick from product library" aria-label="Pick from product library">
        <Library className="h-4 w-4 text-[#0072C6]" />
      </SelectTrigger>
      <SelectContent align="end">
        <SelectGroup>
          <SelectLabel className="text-[11px] uppercase text-slate-500">{category}</SelectLabel>
          {list.map((p) => (
            <SelectItem key={p.id} value={p.id} data-testid={`${id}-option-${p.id}`}>
              <span className="font-medium">{p.name}</span><span className="ml-2 font-mono text-xs text-slate-500">{money(p.premium, cur)}/mo</span>
            </SelectItem>
          ))}
        </SelectGroup>
        {!list.length && <div className="px-2 py-2 text-xs text-slate-500">No saved products. <Link to="/products" className="text-[#0072C6] underline">Add to library</Link></div>}
      </SelectContent>
    </Select>
  );
};
